import useStorageInformation from '~/prix/react/hooks/storage'
import filesize from 'filesize'
import { NavigatorStorageSupported } from '~/utils/shared/platform'

const StorageInformation = () => {
  const storageInformation = useStorageInformation()
  const isSupported = NavigatorStorageSupported
  return (
    <>
      <h2>Armazenamento</h2>
      {isSupported ? (
        <>
          <div className='information'>
            <h3>Armazenamento usado:</h3>
            <span>{filesize(storageInformation?.usage) ?? 'Não encontrado'}</span>
          </div>
          <div className='information'>
            <h3>Armazenamento total:</h3>
            <span>{filesize(storageInformation?.quota) ?? 'Não encontrado'}</span>
          </div>
          <div className='information'>
            <h3>Porcentagem de armazenamento:</h3>
            <span>
              {storageInformation?.usage && storageInformation?.quota
                ? `${((storageInformation?.usage / storageInformation?.quota) * 100).toPrecision(
                    2,
                  )}%`
                : 'Não encontrada'}
            </span>
          </div>
        </>
      ) : (
        <span>Armazenamento não suportado neste navegador.</span>
      )}
    </>
  )
}

export default StorageInformation
